import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./Home";
import About from "./About";
import Footer from "./Footer";
import Header from "./Header";
import Whatwedo from "./Whatwedo";
import FAQ from "./FAQ";
import { ClimbingBoxLoader } from "react-spinners";
import "./App.css"; // Import your CSS file for styling
import { Bounce } from "react-reveal";

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate data loading with a setTimeout
    const timeout = setTimeout(() => {
      setLoading(false); // Set loading to false after 3 seconds
    }, 5000); // Wait for 2 seconds before hiding the loader

    // Clear timeout on component unmount
    return () => clearTimeout(timeout);
  }, []);

  return (
    <div className="app-container">
      <BrowserRouter>
        {/* Conditionally render ClimbingBoxLoader while loading */}
        {loading ? (
          <div className="loader-container">
            <ClimbingBoxLoader color="#FC7800" />
            <Bounce><h4 className="font-medium">Little Strides, Giant Prints</h4></Bounce>
          </div>
        ) : (
          <>
            <Header />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/what_we_do" element={<Whatwedo />} />
              <Route path="/faq" element={<FAQ />} />
            </Routes>
            <Footer />
          </>
        )}
      </BrowserRouter>
    </div>
  );
}

export default App;
